export default function LoginSecurity() {
  return (
    <div>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Login &amp; Security</h2>
      <p className="text-sm text-text_muted">Update your password and security settings.</p>
    </div>
  );
}
